import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import {CardContainer, Notification} from 'components/common/uiKit';

function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-auto-tabpanel-${index}`}
            aria-labelledby={`scrollable-auto-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3} className='p-0'>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `scrollable-auto-tab-${index}`,
        'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
}

class TabComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.value || 0
        }
    }

    handleChange = (event, newValue) => {
        this.setState({value: newValue});
    };

    render() {
        const {value} = this.state;
        const {data} = this.props;

        if (!data)
            return (<div></div>);


        return (
            <div>
                <CardContainer disablePadding>
                    <Tabs
                        value={value}
                        onChange={this.handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth"
                        selectionFollowsFocus
                        //scrollButtons="auto"
                        scrollButtons="off"
                    >
                        {data.map((tab, index) => {
                            return (
                                <Tab label={tab.title} {...a11yProps(index)}
                                     className={`p-0 ${tab.disabled && 'disabled'}`}/>
                            );
                        })}
                    </Tabs>
                </CardContainer>

                {data.map((tab, index) => {
                    let Component = tab.component;
                    return (
                        <TabPanel value={value} index={index}>
                            <Component {...tab.params}/>
                        </TabPanel>
                    );
                })}
            </div>
        );
    }
}

export default TabComponent;
